<template>
  <div class="picker">
    <label :for="model.city.$key">
      {{ model.city.$schema.title }}
    </label>

    <v-select
      :class="{'is-invalid': this.model.city.$error}"
      :disabled="cityDisabled"
      :inputId="model.city.$key"
      :options="cities"
      :value="cityValue"
      @search:blur="blur"
      @search:focus="focus"
      @input="selectedCity"
    >
      <template v-slot:no-options>
        {{ emptyListMsg }}
      </template>
    </v-select>

    <w-error v-if="showError" :model="this.model.city"></w-error>
  </div>
</template>

<script>
import axios from 'axios';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

import WError from './error.vue';

// @vuese
// Input na SIMC-a
// @group Components
export default {
  name: 'w-simc-picker',
  components: {vSelect, WError},
  props: {
    // URL do TERYT API
    url: {
      type: String,
      required: true
    },
    // Schema
    model: {
      type: Object,
      required: true
    },
    // Wartość TERC-a
    terc: {
      type: String,
      required: true
    },
    // Tekst do wyświetlenia w przypadku pustej listy
    emptyListMsg: {
      type: String,
      required: false,
      default: ''
    },
    // Czy pokazywać błędy
    showError: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      cities: [],
      cityValue: undefined
    };
  },
  computed: {
    cityDisabled() {
      return this.terc.length === 6 ? false : true;
    }
  },
  watch: {
    'model.simc.$value'(val) {
      this.setCityData(val);
    },
    terc(newValue) {
      this.selectedCity(undefined);

      this.getCityList();
    }
  },
  methods: {
    // @vuese
    // Blur na polu schemy
    blur() {
      this.model.city.$hasFocus = false;
    },
    // @vuese
    // Focus na polu schemy
    focus() {
      this.model.city.$hasFocus = true;
    },
    // @vuese
    // Pobiera listę miejscowości
    getCityList() {
      if (this.terc.length === 6) {
        axios
          .get(`${this.url}/simc/?terc=${this.terc}`)
          .then(res => {
            this.cities = res.data.list.map(item => ({value: item.symbol, label: item.name}));
            if (this.cities.length === 1) {
              this.selectedCity(this.cities[0]);
            }
          })
          .catch(error => this.$emit('error', 'Nie udało się pobrać listy miejscowości'));
      } else {
        this.$set(this, 'cities', []);
      }
    },
    // @vuese
    // Zapisuje wybraną wartość w schemie
    // @arg `val` - obiekt z nazwą oraz symbolem miejscowości
    selectedCity(val) {
      this.$set(this, 'cityValue', val);

      this.model.$setData({
        city: val ? val.label : '',
        simc: val ? val.value : ''
      });
    },
    // @vuese
    // Pobiera i ustawia miejscowość w formularzu
    // @arg `simc` - kod SIMC
    setCityData(simc) {
      if (simc) {
        axios
          .get(`${this.url}/simc/?terc=${this.terc}&symbol=${simc}`)
          .then(res => this.$set(this, 'cityValue', res.data.list.map(item => ({value: item.symbol, label: item.name}))[0]))
          .catch(error => this.$emit('error', 'Nie udało się pobrać miejscowości'));
      }
    }
  },
  beforeMount() {
    this.getCityList();

    if (this.model.simc) {
      this.setCityData(this.model.simc.$value);
    }
  }
};
</script>

<style>
.picker {
  margin-bottom: 25px;
}

.is-invalid .vs__dropdown-toggle {
  border-color: #fd3995;
}
</style>
